"use client";

import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Activity } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function MetabolicTesting() {
  return <section id="vo2maxmetabolictesting" data-nav="light" className="bg-background text-foreground py-12 md:py-16 border-t border-border">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <motion.div initial={{
        opacity: 0,
        y: 8
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.35,
        ease: "easeOut"
      }} className="rounded-xl border border-border bg-card text-card-foreground p-6 sm:p-8 shadow-xs">
          <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6">
            <div className="space-y-4 max-w-2xl">
              <div className="flex items-center gap-2.5">
                <span className="flex size-8 shrink-0 items-center justify-center rounded-lg bg-secondary text-primary">
                  <Activity className="size-4" aria-hidden="true" />
                </span>
                <h2 className="text-xl sm:text-2xl font-semibold tracking-tight text-foreground font-default">
                  VO₂ Max &amp; Metabolic Testing
                </h2>
              </div>

              <p className="text-base text-muted-foreground leading-relaxed">
                PhysAnalytica also provides specialist aerobic and metabolic
                testing using the KORR CardioCoach MAX. Contact the partnership
                clinic to confirm current testing availability at Batchwood.
              </p>

              <p className="text-xs sm:text-sm text-muted-foreground/90 border-t border-border/60 pt-3">
                PhysioGenics manages the patient&apos;s healthcare and wellbeing
                pathway at Batchwood, while PhysAnalytica provides biomechanics
                expertise, technology and specialist support across services.
              </p>
            </div>

            <div className="shrink-0 self-start md:self-center">
              <Button asChild variant="outline" size="sm" className="gap-2">
                <Link to="#">
                  <span>View testing details</span>
                  <ArrowRight className="size-3.5" aria-hidden="true" />
                </Link>
              </Button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}